import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateOrganizationAvatarPayload = {
  avatar: File | null;
  id?: number;
};
type UpdateOrganizationAvatarResponse = any;

export const updateOrganizationAvatar = async (
  payload: UpdateOrganizationAvatarPayload
): Promise<UpdateOrganizationAvatarResponse> => {
  try {
    const formData = new FormData();

    let data: UpdateOrganizationAvatarResponse;

    if (payload.avatar) {
      formData.append('avatar', payload.avatar);
      data = await apiService.post<UpdateOrganizationAvatarResponse>(
        `/organizations/${payload.id}/avatar/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    } else {
      data = await apiService.delete<UpdateOrganizationAvatarResponse>(
        `/organizations/${payload.id}/avatar/`
      );
    }

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
